export default "__VITE_ASSET__Bl20VUYN__"